var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[(_vm.crag)?_c('publication-list',{attrs:{"publishable":_vm.crag,"publishable-type":"Crag"}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }